exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common_form_search[data-v-3decdf0f]{padding:15px 15px 0 15px;background-color:#ffffff;border-radius:0 0 10px 10px}.child_page[data-v-3decdf0f]{padding:15px}[data-v-3decdf0f] .el-divider--horizontal{margin:0}\n", ""]);

// exports
